import React from 'react'
import Footer from '../component/Footer'
import Header from '../component/Header'
import FileDownloadDoneIcon from '@mui/icons-material/FileDownloadDone';
import { motion } from "framer-motion";
import Why from './Why';
import Steps from '../component/Steps';
import Process from '../component/Process';
import Stats from '../component/Stats';
import { Link } from 'react-router-dom';

export default function Service() {
    const container = {
        hidden: {},
        visible: {
            transition: {
                staggerChildren: 0.18,
                delayChildren: 0.2,
            },
        },
    };

    const fadeUp = {
        hidden: {
            opacity: 0,
            y: 30,
        },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.6,
                ease: "easeOut",
            },
        },
    };
    const cardHover = {
        y: -6,
        boxShadow: "0px 20px 40px rgba(0,255,255,0.08)",
        transition: { duration: 0.3 },
    };


    const loanOptions = [
        {
            icon: <FileDownloadDoneIcon className='text-white' />,
            title: 'Instant Loan',
            description: 'Suitable for short-term financial requirements and time-sensitive everyday expenses.',
            borderColor: 'border-blue-500',
            url: 'instant-loan',
            ideal: 'utility bills, small expenses, and temporary gaps'
        },
        {
            icon: <FileDownloadDoneIcon className='text-white' />,
            title: 'Emergency Loan',
            description: 'Designed for urgent financial situations, such as medical needs, emergency travel, and unexpected commitments.',
            borderColor: 'border-blue-500',
            url: 'emergency-loan',
             ideal: 'medical needs, urgent travel, and unexpected situations'
        },
        {
            icon: <FileDownloadDoneIcon className='text-white' />,
            title: 'Personal Loan',
            description: "Suitable for larger planned expenses and important life commitments, subject to eligibility.",
            borderColor: 'border-blue-500',
            url: 'personal-loan',
            ideal: 'planned expenses and larger commitments'
        }
    ];
    return (
        <>
            <Header />
            {/* banner section start */}
            <div className="relative h-[300px] flex items-center justify-center bg-gradient-to-br from-[#0b1f3a] to-[#0a2540] overflow-hidden">
                {/* Animated Background Glow */}
                <div className="absolute w-[400px] h-[400px] bg-blue-500/20 rounded-full blur-3xl animate-pulse top-[-100px] left-[-100px]" />
                <div className="absolute w-[300px] h-[300px] bg-orange-400/20 rounded-full blur-3xl animate-pulse bottom-[-80px] right-[-80px]" />

                {/* Glass Card */}
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    className="px-10 py-8 text-center "
                >
                    {/* Title */}
                    <motion.h1
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ delay: 0.3 }}
                        className="text-4xl md:text-5xl font-bold text-white"
                    >
                        Our <span className="text-orange-400">Services</span>
                    </motion.h1>

                    {/* Subtitle */}
                    <motion.p
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.5 }}
                        className="mt-4 text-gray-200 text-sm md:text-base"
                    >
                        Designed Around Everyday Financial Needs
                        {/* <span className="text-orange-400 font-semibold">
                            Your Ambitions
                        </span> */}
                    </motion.p>
                </motion.div>
            </div>

            {/* end */}

            <div className="size-full flex items-center justify-center bg-gray-50 py-20">
                <div className="max-w-7xl mx-auto">
                    <p className="ms-text-secondary uppercase font-semibold text-lg mb-2">Explore Your Options</p>
                    <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 leading-snug mb-4">
                       Lending Solutions Built Around Your Needs
                    </h2>
                    <p className=' text-gray-500 text-sm sm:text-base leading-8 pb-10'>Helping salaried professionals manage urgent expenses and temporary salary-cycle gaps.</p>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8 ">
                        {loanOptions.map((option, index) => (
                            <div
                                key={index}
                                className="rounded-lg shadow-lg  p-6 flex flex-col border border-gray-200" style={{ borderLeft: '5px solid #FF8C00' }}
                            >
                                <div className="bg-[#001F3F] rounded-lg w-12 h-12 flex items-center justify-center mb-4">
                                    {option.icon}
                                </div>

                                <h3 className="text-xl mb-3 font-bold">{option.title}</h3>

                                <p className="text-gray-600 text-base leading-7 mb-6 flex-grow">
                                    {option.description}
                                </p>
                                <p className='mb-6'> <b>Ideal for : </b> {option.ideal}</p>

                                {/* <Link to={`/${option.url}`}>
                                    <button className="bg-[#f6b640] hover:bg-[#FF8C00] py-3 px-6 rounded-lg transition-colors font-medium">
                                    Know More1
                                </button>
                                </Link> */}
                                <Link to={`./${option.url}`}>
                                    <button className="bg-[#f6b640] hover:bg-[#FF8C00] py-3 px-6 rounded-lg transition-colors font-medium">
                                        Know More
                                    </button>
                                </Link>

                            </div>
                        ))}
                    </div>
                </div>
            </div>


            <Why />
            <div className='pt-5'></div>
            <Process />
            <Stats />
            {/* <Steps /> */}
            <Footer />
        </>
    )
}
